import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <h6>©️ 2022 Sean Watson  | 
        <a href='https://www.linkedin.com/in/sean-watson30/' target='_blank' rel="noopener noreferrer"> LinkedIn </a> | 
        <a href='https://github.com/sean-watson30' target='_blank' rel="noopener noreferrer"> GitHub </a> | 
        <a href="https://seanwatson.netlify.app/" target='_blank' rel="noopener noreferrer"> Portfolio </a>
      </h6>
    </div>
  )
}

export default Footer;